import React from "react";
import Navbar from "./navbar";
import Hero from "./hero";

const landingpage = () => {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
};

export default landingpage;
